<template>
  <div>
    <a-card>
      <div class="index">
        <span
          v-if="!$store.state.userInfo.avatar"
          class="iconfont icon-yonghuming"
          style="font-size: 24px"
          >&nbsp;&nbsp;</span
        >
        <div v-else class="avatar">
          <img :src="$store.state.userInfo.avatar" width="100%" alt="avatar" />
        </div>
        <div class="txt">
          您好啊 ~&nbsp;
          <span class="username" style="color: #0085ee">
            {{ $store.state.userInfo.username }}</span
          >
          欢迎登录
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  height: 120px;
  border-radius: 10px;
  text-align: left;
  padding: 40px 20px;
  font-size: 24px;
  background-color: #f0f6f9;
  display: flex;
  align-items: center;
  .avatar {
    width: 45px;
    height: 45px;
    display: inline-block;
    // border: 1px solid red;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 5px;
    margin-left: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .txt{
    display: inline-block;
    margin-left: 10px;
  }
}
</style>